import { render, staticRenderFns } from "./spareStatementDetail.vue?vue&type=template&id=9f2f7a68&scoped=true"
import script from "./spareStatementDetail.vue?vue&type=script&lang=js"
export * from "./spareStatementDetail.vue?vue&type=script&lang=js"
import style0 from "./spareStatementDetail.vue?vue&type=style&index=0&id=9f2f7a68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2f7a68",
  null
  
)

export default component.exports